import { render } from "./WpePlugins.vue?vue&type=template&id=a4ea4dd6"
import script from "./WpePlugins.vue?vue&type=script&lang=js"
export * from "./WpePlugins.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/info/WpePlugins.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a4ea4dd6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a4ea4dd6', __exports__)) {
    api.reload('a4ea4dd6', __exports__)
  }
  
  module.hot.accept("./WpePlugins.vue?vue&type=template&id=a4ea4dd6", () => {
    api.rerender('a4ea4dd6', render)
  })

}


export default __exports__